import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-452d0a68"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "faqs" };
const _hoisted_2 = ["onClick"];
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "faqs__arrow" }, null, -1));
const _hoisted_4 = ["innerHTML"];
import { ref, onMounted } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'faqs',
    props: {
        d: {}
    },
    setup(__props) {
        const isDesktop = ref(window.innerWidth > 1024);
        const activeIndex = ref(null);
        const toggleFaq = (index) => {
            activeIndex.value = activeIndex.value === index ? null : index;
        };
        // Before enter hook: Start with maxHeight = 0
        const beforeEnter = (el) => {
            el.style.maxHeight = '0';
        };
        // Enter hook: Expand to full height
        const enter = (el) => {
            el.style.maxHeight = el.scrollHeight + 'px';
        };
        // Leave hook: Collapse the element
        const leave = (el) => {
            el.style.maxHeight = '0';
        };
        onMounted(() => {
            toggleFaq(0);
        });
        // Update isDesktop value when the window size changes
        window.addEventListener('resize', () => {
            const width = window.innerWidth;
            isDesktop.value = width > 1024;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.d.faqs, (faq, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["faqs__item", { 'faqs__item--active': activeIndex.value === Number(index), 'container': !isDesktop.value }]),
                        key: index
                    }, [
                        _createElementVNode("div", {
                            class: "faqs__question container",
                            onClick: ($event) => (toggleFaq(Number(index)))
                        }, [
                            _createTextVNode(_toDisplayString(faq.question) + " ", 1),
                            _hoisted_3
                        ], 8, _hoisted_2),
                        _createVNode(_Transition, {
                            name: "faq",
                            onBeforeEnter: beforeEnter,
                            onEnter: enter,
                            onLeave: leave
                        }, {
                            default: _withCtx(() => [
                                (activeIndex.value === Number(index))
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "faqs__answer container",
                                        innerHTML: faq.answer
                                    }, null, 8, _hoisted_4))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 2
                        }, 1024)
                    ], 2));
                }), 128))
            ]));
        };
    }
});
